import { Col, Input, Label } from "reactstrap";
import { BorderedRadios, KohoTheme } from "../../../../Constant";
import { H6 } from "../../../../AbstractElements";
import { BORDERED_RADIO } from "../../../../Data/FormControl/CheckboxAndRadio";

export const BorderedRadio = () => {
  return (
    <Col xl="4" sm="6">
      <div className="card-wrapper border rounded-3 h-100 checkbox-checked">
        <H6 className="sub-title">{BorderedRadios}</H6>
        <div className="form-check radio radio-secondary">
          <Input id="radio22" type="radio"  name="radio1" defaultChecked />
          <Label htmlFor="radio22" check>{KohoTheme}</Label>
        </div>
        {BORDERED_RADIO.map(({ color, text,id }, index) => (
          <div className={`form-check radio radio-${color}`} key={index}>
            <Input id={id} type="radio" name="radio1" />
            <Label htmlFor={id} check>{text}</Label>
          </div>
        ))}
      </div>
    </Col>
  );
};
